import '@styles/main.css';
import { initRequestForm } from './request-form.js';
import {
  initAnchorNav,
  initGalleries,
  initMobileCta,
  initSiteNavigation,
  initStickyHeader,
  normalisePage,
} from './site.js';

document.documentElement.classList.add('js');
const pageName = normalisePage(document.body?.dataset.page);
if (pageName) document.documentElement.dataset.page = pageName;

function initialiseSite() {
  initSiteNavigation();
  initStickyHeader();
  initAnchorNav();
  initRequestForm();
  initGalleries();
  initMobileCta();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialiseSite, { once: true });
} else {
  initialiseSite();
}
